module.exports = __webpack_public_path__ + "img/BANNER_DASH_GREENN.556128a5.png";